export default {
  title: "Blog",
  sections: {
    blogs_hero_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/blog_bg.jpg',
            image_mobile: '/seu/blog_mobile_bg.jpg',
            text: 'Der SEU-Blog',
            text2: 'Aktuelles und Fachthemen für wissensdurstige Ingenieure, Planerinnen und Geomatiker',
            text3: 'Nichts verpassen: Neue Beiträge als Newsletter erhalten',
            placeholder: 'E-mail eingeben',
            buttonLabel: 'Abonnieren'
          }
        },
      }
    },
  }
}
